import { render, staticRenderFns } from "./FilterFeed.vue?vue&type=template&id=77aab816&scoped=true&"
import script from "./FilterFeed.vue?vue&type=script&lang=js&"
export * from "./FilterFeed.vue?vue&type=script&lang=js&"
import style0 from "./FilterFeed.vue?vue&type=style&index=0&id=77aab816&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aab816",
  null
  
)

export default component.exports